'use strict';

angular.module('user')
    .component('signupSuccess', {
        templateUrl: 'js/modules/user/components/signup-success/template.html',
    });
